import FortunaJumbotron from './FortunaJumbotron';

export default FortunaJumbotron;
